import PropTypes from "prop-types";

const PRICING_REPORT_FILTER_SUBTITLE =
  "Filter national price history by date range, product, province, retailer, and provider.";

function formatGeneratedAt(generatedAt) {
  if (!generatedAt) return "";
  const date = generatedAt instanceof Date ? generatedAt : new Date(generatedAt);
  return date.toLocaleString("en-CA", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export default function PricingReportPrintHeader({ header }) {
  if (!header) return null;

  const {
    generatedAt,
    dateFromDisplay,
    dateToDisplay,
    productLabel,
    provinceLabel,
    retailerLabel,
    providersLabel,
    includeQuarterlyLookbackNote,
    quarterlyLookbackYears,
    logoUrl,
    logoAlt,
  } = header;

  const generatedAtDisplay = formatGeneratedAt(generatedAt);

  const filterRows = [
    { label: "From", value: dateFromDisplay },
    { label: "To", value: dateToDisplay },
    { label: "Province", value: provinceLabel },
    { label: "Product", value: productLabel },
    { label: "Retailer", value: retailerLabel },
    { label: "Include providers", value: providersLabel },
    // Discount filter is temporarily off, so do not label results as Regular Pricing.
    // { label: "Discount", value: header.discountLabel },
  ];

  return (
    <header className="pricing-report-print-header">
      <div className="pricing-report-print-header__hero">
        {logoUrl ? (
          <img
            className="pricing-report-print-header__logo"
            src={logoUrl}
            alt={logoAlt || "Retailer logo"}
            loading="eager"
            decoding="sync"
          />
        ) : null}
        <h1 className="pricing-report-print-header__title">Pricing Report</h1>
        <p className="pricing-report-print-header__subtitle">{PRICING_REPORT_FILTER_SUBTITLE}</p>
        {generatedAtDisplay ? (
          <span className="pricing-report-print-header__generated-badge">
            Generated on {generatedAtDisplay}
          </span>
        ) : null}
      </div>

      <table className="pricing-report-print-filters-table">
        <tbody>
          {filterRows.map((row) => (
            <tr key={row.label}>
              <th scope="row">{row.label}</th>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {includeQuarterlyLookbackNote ? (
        <div className="pricing-report-print-header__footnotes">
          <p className="pricing-report-print-header__note">
            Quarterly chart lookback: {quarterlyLookbackYears} year
            {quarterlyLookbackYears === 1 ? "" : "s"}
          </p>
        </div>
      ) : null}
    </header>
  );
}

PricingReportPrintHeader.propTypes = {
  header: PropTypes.shape({
    generatedAt: PropTypes.instanceOf(Date),
    dateFromDisplay: PropTypes.string,
    dateToDisplay: PropTypes.string,
    productLabel: PropTypes.string,
    provinceLabel: PropTypes.string,
    retailerLabel: PropTypes.string,
    providersLabel: PropTypes.string,
    discountLabel: PropTypes.string,
    includeQuarterlyLookbackNote: PropTypes.bool,
    quarterlyLookbackYears: PropTypes.number,
    logoUrl: PropTypes.string,
    logoAlt: PropTypes.string,
  }),
};
